import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import ErrorIcon from "assets/icons/error.svg";
import NoResultsIcon from "assets/icons/noResults.svg";

const NO_RESULTS_KEYS: Record<string, string> = {
  MyNews: "MY_NEWS_NO_NEWS",
  MyDocuments: "MY_DOCUMENTS_DOCUMENT_NOT_FOUND",
  MyTimesheet: "MY_TIMESHEET_NO_WORKING_TIME_REPORT_DATA",
};

type ModuleType = keyof typeof NO_RESULTS_KEYS | "MyTime" | string;

interface OcIconForStateProps {
  data?: any[];
  loading: boolean;
  error?: any;
  isMobile: boolean;
  module: ModuleType;
}

export const OcIconForState: React.FC<OcIconForStateProps> = ({
  data = [],
  loading,
  error,
  isMobile,
  module,
}) => {
  const { t } = useTranslation();
  const isEmpty = Array.isArray(data) && data.length === 0;

  if (loading) {
    return null;
  }

  if (module === "MyTime" && isEmpty && !error) {
    return (
      <Box sx={{ textAlign: "center" }}>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img
            alt="orgware-icon"
            src="/img/OK.svg"
            style={{ width: isMobile ? "100%" : 500 }}
          />
        </Box>
        <Box height="36px" />
        <Typography variant="body1">
          {t("MY_TIME_REQUEST_NOT_FOUND")}
        </Typography>
        <Box height="16px" />
        <Typography variant="body1">
          {t("MY_TIME_NO_UNCLOSED_PERIOD")}
        </Typography>
        <Box height="16px" />
      </Box>
    );
  }

  if (!isEmpty && !error) {
    return null;
  }

  const isError = Boolean(error && isEmpty);
  const iconSrc = isError ? ErrorIcon : NoResultsIcon;
  const labelKey =
    isError
      ? "OC_TEMPORARY_ERROR_TEXT"
      : NO_RESULTS_KEYS[module];

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <img
          alt={labelKey}
          src={iconSrc}
          style={{ width: isMobile ? "100%" : 500 }}
        />
      </Box>
      <Box height="16px" />
      <Typography variant="body1">
        {t(labelKey)}
      </Typography>
    </Box>
  );
};

export default OcIconForState;
